// @ts-strict-ignore
import type {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {QuerySegmentEntry, SelectorTypeDefinitions} from 'common/query-builder/query-entry-section/types';
import {
  isEventBasedBehavioralSegmentation,
  isRevenueBehaviorSegmentation,
} from 'common/query-builder/query-entry-section/row-types/behavior/utils';
import {Segmentation} from 'common/types/reports/query';
import {isListOfObjectsSegment} from 'common/query-builder/query-block/segment-menu/types';

// eslint-disable-next-line import/no-cycle
import {SegmentEntryRow} from './index';

export const helpers: EntryRowTypeHelpers<QuerySegmentEntry> = {
  component: SegmentEntryRow,
  getNewEntry: () => ({
    type: SelectorTypeDefinitions.Segment,
    filtersOperator: null,
    filters: [],
    event: null,
  }),
  isPlaceholder({entry}) {
    if (
      isEventBasedBehavioralSegmentation(entry.event) &&
      (entry.event.behavior?.property?.value === null ||
        entry.event.behavior?.event?.value === null ||
        entry.event.behavior?.aggregationOperator === null)
    ) {
      return true;
    }

    if (isRevenueBehaviorSegmentation(entry.event)) {
      return !entry.event.behavior.property.value;
    }

    const segmentation = entry.event as Segmentation;

    if (isListOfObjectsSegment(segmentation) && Boolean(segmentation?.listItemGroup?.propertyName) === false) {
      return true;
    }

    return Boolean(entry.event) === false;
  },
  isIntermediatePlaceholder(row) {
    return this.isPlaceholder(row) && !!row.entry.event;
  },
};
